export const SET_FILTER = 'filter/SET_FILTER';

export const setFilter = (name, value) => ({
  type: SET_FILTER,
  payload: {
    name,
    value
  }
});
